import React from 'react';

import PlaceholderTab from '~/components/Offers/Detail/OfferBuilder/shared/PlaceholderTab';

import { PARITY_CSV_FIELDS } from './fields';

export default function ParityCsvTab() {
  return <PlaceholderTab configuredFieldCount={PARITY_CSV_FIELDS.length} title="Parity / CSV Data" />;
}
